import { Api } from "src/core/services/api.services";
import { useService } from "src/hook/useServices";
import LayoutMain from "src/shared/layouts/LayoutMain/LayoutMain";
import { Brief } from "src/shared/interface/brief";
import BcLoading from "src/shared/components/Bc-Loading/Bc-Loading";
import {
  BCButton,
  BCFormList,
  BCFormListCont,
} from "src/shared/styled/global.styled";
import BCTag from "../../../shared/components/Bc-Tag/Bc-Tag";
import { useNavigate } from "react-router-dom";
import BcIcon from "src/shared/components/Bc-Icon/Bc-icon";
import { useState } from "react";
import BcModal from "src/shared/components/Bc-Modal/Bc-Modal";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { TypeBrief } from "src/shared/enums/type-brief.enum";
import { Role } from "src/constants/roles";

const briefsAll = async (): Promise<Brief[]> => {
  const { data } = await Api.Brief().then((api) => api.getAll<Brief>());
  return data;
};

const deleteBrief = async (id: string): Promise<void> => {
  console.log(id);
  const { data } = await Api.Brief().then((api) => api.remove<void>(id));
  return data;
};

const BriefList = () => {
  const serviceQuery = useService("briefsAll", briefsAll);
  const queryClient = useQueryClient();

  const [openDiag, setOpenDiag] = useState<boolean>(false);
  const [idDelete, setIdDelete] = useState<string>("");

  const handleModal = (id = "") => {
    setIdDelete(id);
    setOpenDiag(!openDiag);
  };

  const linkEdit = (key: string) => {
    switch (key) {
      case TypeBrief.CAMPANA:
        return "campaign";
      case TypeBrief.INICIATIVA:
        return "iniciative";
      case TypeBrief.TACTICA:
        return "tactic";
    }
  };

  const deleteMutation = useMutation(deleteBrief, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["briefsAll"],
        refetchType: "active",
      });
      setIdDelete("");
      handleModal();
      window.location.reload();
    },
  });

  const navigate = useNavigate();

  return (
    <LayoutMain
      className="main-center"
      idPage="Listado de Briefs"
      titlePage={true}
      requiredRoles={[Role.ADMIN as string]}
    >
      <section className="bc-container-list">
        {serviceQuery.isFetching && (
          <BcLoading messages="Cargando todos los Brief" />
        )}
        {serviceQuery.isSuccess &&
          (serviceQuery.data as Brief[]).length === 0 && (
            <h1 className="text-center">
              No hay Briefs creados en la plataforma
            </h1>
          )}

        {serviceQuery.isError && (
          <h1 className="text-center">
            Error al cargar los datos intente mas tarde
          </h1>
        )}

        {serviceQuery.isSuccess &&
          (serviceQuery.data as Brief[]).map((brief: Brief) => (
            <BCFormList className="bc-card" key={brief.id}>
              <BCFormListCont>
                <span>
                  <p>
                    <strong>Tipo: </strong>
                  </p>{" "}
                  <p>{brief.briefType}</p>
                </span>
                <span>
                  <strong>Nombre: </strong> <p>{brief.fields.name}</p>
                </span>
                <span>
                  <strong>Nivel: </strong> <p>{brief.fields.nivel}</p>
                </span>
                <span>
                  <strong>Usuario: </strong> <p>{brief.user}</p>
                </span>
                <span>
                  <strong>Version: </strong> <p>{brief.version}</p>
                </span>
                <span>
                  <BCTag status={brief.status} />
                </span>
                {/* <p>{JSON.stringify(brief)}</p> */}
              </BCFormListCont>
              <div className="bc-flex bc-justify-content-flex-end">
                <BCButton
                  type="button"
                  className="bc-button-secondary bc-button-small"
                  onClick={() => navigate(`/brief/ver/${brief.id}`)}
                >
                  Ver
                </BCButton>
                <BCButton
                  type="button"
                  className="bc-button-primary bc-button-small"
                  disabled={false}
                  onClick={() => navigate(`/brief/editar/${linkEdit(brief.briefType)}/${brief.id}`)}
                >
                  Editar
                </BCButton>
                <BCButton
                  type="button"
                  className="bc-button-primary bc-button-small"
                  disabled={false}
                  onClick={() => handleModal(brief.id as string)}
                >
                  <BcIcon iconName="erase" />
                </BCButton>
              </div>
            </BCFormList>
          ))}
      </section>
      <BcModal
        openModal={openDiag}
        type="error"
        title="Eliminar Registro "
        onClose={handleModal}
      >
        <section className="bc-modal-content">
          <div className="text-center bc-mb-2 bc-mt-2">
            <p>¿Estas seguro de eliminar este Brief?</p>
          </div>
        </section>
        <section className="bc-modal-button-container">
          <BCButton
            type="button"
            className="bc-button-primary bc-button-small"
            tabIndex={0}
            onClick={() => deleteMutation.mutate(idDelete as string)}
          >
            Aceptar
          </BCButton>
        </section>
      </BcModal>
    </LayoutMain>
  );
};

export default BriefList;
